import { isObject } from 'lodash-es';

const objectPick = (data, handler, reserve) => {
  if (!isObject(data)) return data;
  else {
    const result = {};
    for (const i in data) {
      if (data.hasOwnProperty(i) && (!reserve || !reserve.includes(i)) && handler(data[i])) {
        result[i] = data[i];
      }
    }
    return result;
  }
};

export { objectPick };
//# sourceMappingURL=objects.mjs.map
